// @flow
import React from 'react';
import Box from '@waglabs/box';
import Flex from '@waglabs/flex';
import Image from '@waglabs/image';
import Icon from '@waglabs/icon';
import Span from '@waglabs/span';

import Text from '../../../../../Text';
import { OrderNowButton } from '../../../OrderNowButton';

import recommendedRibbonSvg from './assets/recommended-ribbon.svg';

type PlanFeature = {
  key: string,
  description: string,
};

type Plan = {
  buttonTestId: string,
  features: PlanFeature[],
  key: string,
  planType: number,
  price: string,
  subTitle1: string,
  subTitle2: string,
  title: string,
  extraInfo?: string,
  isFree?: boolean,
  recommended?: boolean,
};

type Props = {
  plan: Plan,
  search: string,
};

type PriceProps = {
  price: string,
};

const PriceFree = ({
  price,
}: PriceProps) => (
  <>
    <Span
      fontFamily="bodyMuli"
      textDecoration="line-through"
    >
      {price}
    </Span>
    {' '}
    <Span
      ml={2}
    >
      FREE
    </Span>
  </>
);

export const PlanCard = ({
  plan,
  search,
  ...rest
}: Props) => (
  <Flex
    alignItems="center"
    border={1}
    borderColor="lightGrey"
    borderRadius="10px"
    flexDirection="column"
    justifyContent={['flex-start', 'space-between']}
    width={['90%', '343px', '440px']}
    mb={['24px', 0]}
    {...rest}
  >
    {plan.recommended && (
      <Image
        alt="Recommended ribbon"
        mt="-32px"
        src={recommendedRibbonSvg}
        width="216px"
      />
    )}
    <Box>
      <Text
        color="medPurple"
        fontFamily="bodyMuli"
        fontSize={8}
        fontWeight="bold"
        mt={3}
        mb="24px"
        textAlign="center"
      >
        {plan.title}
      </Text>

      <Box
        width={['260px', '286px']}
      >
        {plan.features.map(feature => (
          <Flex
            alignItems="baseline"
            key={feature.key}
          >
            <Icon
              width="15px"
              height="15px"
              name="checkmarkGreen"
            />
            <Text
              fontFamily="bodyMuli"
              fontSize={3}
              ml="16px"
            >
              {feature.description}
            </Text>
          </Flex>
        ))}
        {plan.extraInfo && (
          <Box>
            <Text
              fontFamily="bodyMuli"
              fontSize={1}
              mt={3}
            >
              {plan.extraInfo}
            </Text>
          </Box>
        )}
      </Box>
    </Box>

    <Box
      mb={[3, 3, 4]}
      boxSizing="border-box"
      px={[3, 3, 4]}
      width="100%"
    >
      <Text
        fontFamily="bodyMuli"
        fontSize={[10, 11]}
        fontWeight={1}
        lineHeight={1}
        mb="18px"
        mt="48px"
        textAlign="center"
      >
        {plan.isFree ? <PriceFree price={plan.price} /> : plan.price}
      </Text>
      <Text
        fontFamily="bodyMuli"
        color="wagGray"
        fontSize={2}
        mt={0}
        textAlign="center"
      >
        {plan.subTitle1}
      </Text>
      <Text
        color="#9b9b9b"
        fontFamily="bodyMuli"
        fontSize="14px"
        fontWeight="bold"
        mb={3}
        textAlign="center"
      >
        {plan.subTitle2}
      </Text>

      <OrderNowButton
        dataTestId={plan.buttonTestId}
        planType={plan.planType}
      />
    </Box>
  </Flex>
);
